import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_5 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_Sepa = _resolveComponent("Sepa")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pr-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentMenu, {
                  MenuOptions: _ctx.documentMenuOptions,
                  onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                  onDisplayFile: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showAccountingLines = false; _ctx.displayActivity = false;}),
                  onDisplayAccountingLine: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showAccountingLines = true; _ctx.displayActivity = false;}),
                  onDownload: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startDownloadFile())),
                  onActivity: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayActivity = true)),
                  onDelete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteDocumentDialog = true))
                }, null, 8, ["MenuOptions"]),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    (_ctx.isPDF)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ossPdf, {
                              documentId: _ctx.document.id
                            }, null, 8, ["documentId"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showAccountingLines && !_ctx.displayActivity && _ctx.isAccountingUser)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "12",
                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_accounting_item_static, {
                              companyId: _ctx.companyId,
                              documentId: _ctx.document.id,
                              mode: _ctx.isAccountingItem ? 'AllOption' : 'Embedded',
                              ref: "accountingItemStatic",
                              key: _ctx.accountingLinesRefreshKey,
                              onUpsert: _ctx.onAccountingItemUpdated
                            }, null, 8, ["companyId", "documentId", "mode", "onUpsert"]))
                          ]),
                          _: 1
                        }))
                      : (_ctx.displayActivity)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "12",
                            style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_UsersActivitiesHistory, {
                                documentId: _ctx.document.id
                              }, null, 8, ["documentId"])
                            ]),
                            _: 1
                          }))
                        : (_ctx.document.signedUrl)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "12",
                              style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                            }, {
                              default: _withCtx(() => [
                                (_ctx.xml)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      innerHTML: _ctx.xml
                                    }, null, 8, _hoisted_2))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.xmlAsString), 1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.associatedFields.show)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 0,
                  style: _normalizeStyle(_ctx.svgPosition)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `field-${_ctx.document.id}-${key}-${index}`,
                        onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                        class: "oss-list-item"
                      }, null, 8, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "my-0 pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"calc(100vh - 82px)","overflow-y":"auto"},
              class: "default_card_wm elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              "single-line": "",
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                _createElementVNode("b", null, "Statut", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                            _ctx.document.errorMessage &&
                                                            _ctx.reUploadDocument
                                                        )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Erreur : " + _toDisplayString(_ctx.document.errorMessage), 1))
                                                  : (_ctx.document.errorMessage)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Erreur de lecture du fichier : contacter votre cabinet "))
                                                    : (
                                                            _ctx.document.status === 'ORIGINAL_UPLOADED'
                                                        )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " En attente d'analyse "))
                                                      : (_ctx.document.status === 'UPLOADED')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " En attente d'analyse "))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_8, "OK"))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item my-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              style: {"border-right":"1px #ededed solid","height":"28px"},
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                _createElementVNode("b", null, "Type", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCategory(_ctx.document.type)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.showRestoreDocumentBtn)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      ripple: false,
                                      class: "mb-2",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              "no-gutters": "",
                                              class: "align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "3",
                                                  style: {"border-right":"1px #ededed solid"}
                                                }, {
                                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                    _createElementVNode("b", null, "Actions", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "9",
                                                  class: "d-flex justify-end align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canBeRestoredTooltipMessages?.length)
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          class: "pt-4 px-4",
                                                          location: "bottom"
                                                        }, {
                                                          activator: _withCtx(({ props }) => [
                                                            _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                                              _createVNode(_component_v_btn, {
                                                                rounded: "",
                                                                elevation: "0",
                                                                disabled: "",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _cache[17] || (_cache[17] = _createTextVNode(" Restaurer ")),
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "small",
                                                                    location: "end"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                                      _createTextVNode(" $oss-edit ")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              })
                                                            ], 16)
                                                          ]),
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canBeRestoredTooltipMessages, (line) => {
                                                              return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(line), 1))
                                                            }), 256))
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.restoreDialog = true)),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _cache[19] || (_cache[19] = _createTextVNode(" Restaurer ")),
                                                            _createVNode(_component_v_icon, {
                                                              size: "small",
                                                              location: "end"
                                                            }, {
                                                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                                _createTextVNode(" $oss-edit ")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.activateTagguing)
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FreeTag, {
                                  companyTags: _ctx.allCompanyTags,
                                  document: _ctx.inDocument,
                                  splitUserPartitions: true,
                                  onChanged: _ctx.startToBeDoneIfNecessary
                                }, null, 8, ["companyTags", "document", "onChanged"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end align-center py-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Sepa, {
                              mode: 'Embedded',
                              companyId: _ctx.companyId,
                              document: _ctx.inDocument,
                              onOnUpdated: _ctx.onUpdated
                            }, null, 8, ["companyId", "document", "onOnUpdated"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center align center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              disabled: _ctx.previousDisabled(),
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.previous()))
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_v_btn_next, {
                              disabled: _ctx.nextDisabled(),
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.next()))
                            }, null, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_DocumentWizardDialog, {
      active: _ctx.activeUploadDocument,
      "onUpdate:active": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeUploadDocument) = $event)),
      companyId: _ctx.companyId,
      documentId: _ctx.document.id,
      documentType: _ctx.document.type,
      showFirstPrevious: false,
      multiple: false,
      onFileUploaded: _ctx.onFileUploaded
    }, null, 8, ["active", "companyId", "documentId", "documentType", "onFileUploaded"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[20] || (_cache[20] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 0,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          status: 'INFORMATION_REQUEST',
          showSmartChat: false
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.restoreDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.restoreDialog) = $event)),
      title: "Restaurer le document",
      onValid: _cache[12] || (_cache[12] = ($event: any) => {
                _ctx.restoreDocument();
                _ctx.restoreDialog = false;
            }),
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.restoreLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[21] || (_cache[21] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir restaurer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "validLoading"])
  ]))
}